<template>
  <div class="app">
    <!-- Sidebar -->
    <aside class="sidebar">
      <div class="brand">撩天空間</div>

      <nav class="nav">
        <router-link to="/" class="navItem" :class="{ isActive: $route.path === '/' }">
          <span class="dot"></span>
          <span>主頁</span>
        </router-link>
        <router-link to="/characters" class="navItem" :class="{ isActive: $route.path === '/characters' }">
          <span class="dot"></span>
          <span>最近聊天</span>
        </router-link>
        <router-link to="/wallet" class="navItem" :class="{ isActive: $route.path === '/wallet' }">
          <span class="dot"></span>
          <span>我的錢包</span>
        </router-link>
        <router-link to="/profile" class="navItem" :class="{ isActive: $route.path === '/profile' }">
          <span class="dot"></span>
          <span>我的資料</span>
        </router-link>
      </nav>

      <div class="sidebarFooter">
        <div class="userChip">
          <div class="avatar">E</div>
          <div class="userMeta">
            <div class="userName">Ethan</div>
            <div class="userSub">mock user</div>
          </div>
        </div>
        <button class="logoutBtn" title="登出">↩</button>
      </div>
    </aside>

    <!-- Main Content Area -->
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
// Main layout component with sidebar navigation
</script>

<style scoped>
/* Layout */
.app {
  height: 100vh;        /* ✅ 固定視窗高，不要用 min-height */
  overflow: hidden;     /* ✅ 不讓整頁跟著右邊一起捲 */
  display: grid;
  grid-template-columns: 240px 1fr;
  background: radial-gradient(1200px 600px at 40% -10%, rgba(255,255,255,0.08), transparent 55%),
              linear-gradient(180deg, #0b0f17, #070a10);
  color: rgba(255,255,255,0.92);
}

/* Sidebar */
.sidebar {
  height: 100%;         /* ✅ 撐滿 app 高度 */
  min-height: 0;        /* ✅ grid/flex 內避免被內容撐破（超關鍵） */
  overflow: hidden;     /* ✅ 左邊不需要捲軸（你要 footer 一直可見） */

  padding: 18px 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02));
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Main */
.main {
  min-width: 0;
  min-height: 0;        /* ✅ 讓 overflow 生效（grid 內超關鍵） */
  overflow: auto;       /* ✅ 只有右邊 router-view 捲動 */
  height: 100%;
}

.brand {
  font-size: 20px;
  font-weight: 800;
  text-align: center;
  padding: 8px;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px;
  border-radius: 16px;
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.06);
}

.navItem {
  appearance: none;
  border: 1px solid rgba(255,255,255,0.06);
  width: 100%;
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255,255,255,0.03);
  color: rgba(255,255,255,0.78);
  display: flex;
  align-items: center;
  gap: 10px;
  transition: 160ms ease;
  text-decoration: none;
}

.navItem:hover {
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.10);
  color: rgba(255,255,255,0.92);
}

.navItem.isActive {
  background: rgba(167, 139, 250, 0.14);
  border-color: rgba(167, 139, 250, 0.26);
  color: rgba(255,255,255,0.96);
}

.navItem.isActive::before {
  content: "";
  display: none;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(255,255,255,0.22);
}

.sidebarFooter {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.userChip {
  flex: 1;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
  border-radius: 14px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.06);
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(255,255,255,0.10);
  font-weight: 800;
}

.userMeta {
  min-width: 0;
}

.userName {
  font-weight: 700;
  font-size: 13px;
  line-height: 1.1;
}

.userSub {
  font-size: 11px;
  opacity: 0.7;
}

.logoutBtn {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.04);
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  transition: 160ms ease;
}

.logoutBtn:hover {
  background: rgba(255,255,255,0.07);
}

/* Responsive */
@media (max-width: 980px) {
  .app { 
    grid-template-columns: 86px 1fr; 
  }
  .brand { 
    font-size: 16px; 
  }
  .navItem span:last-child { 
    display: none; 
  }
  .userMeta { 
    display: none; 
  }
}
</style>
